/// <reference types="./archivingGetEntityInfo.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
import { queryNoneOrOne } from '../QueryFunctions.js';
import { resolveEntityStatus } from '../utils/CodecUtils.js';
export async function adminEntityArchivingGetEntityInfo(database, context, reference) {
    const result = await queryNoneOrOne(database, context, {
        text: 'SELECT e.id, e.type, e.auth_key, e.resolved_auth_key, e.status, e.updated_at, e.never_published, e.latest_entity_versions_id FROM entities e WHERE e.uuid = ?1',
        values: [reference.id],
    });
    if (result.isError())
        return result;
    if (!result.value) {
        return notOk.NotFound('No such entity');
    }
    const { id: entityInternalId, latest_entity_versions_id: versionId, type, auth_key: authKey, resolved_auth_key: resolvedAuthKey, status, updated_at: updatedAt, never_published: neverPublished, } = result.value;
    return ok({
        entityInternalId,
        entityVersionInternalId: versionId,
        type,
        authKey,
        resolvedAuthKey,
        status: resolveEntityStatus(status),
        updatedAt: new Date(updatedAt),
        neverPublished: !!neverPublished,
    });
}
//# sourceMappingURL=archivingGetEntityInfo.js.map